import * as React from 'react';
import { actionCreators } from './actions';
import { containerFactory } from 'app/infrastructure/redux/index';
import { STATE } from 'app/constants';
import { safeNumericString } from 'app/infrastructure/data/sanitize';
import { SpinLoader } from 'app/components/spin-loader';

/**
 * Runs the action creator to duplicate entity then redirects to the draft
 *
 */
export class CaseDuplicate extends React.PureComponent<any> {

  public static statePath: string = STATE.case;

  public componentDidMount() {
    this.props.duplicateCase(safeNumericString(this.props.params.id));
  }

  public render(): any { return <SpinLoader /> }
}

const container = containerFactory(CaseDuplicate, actionCreators);

export { container as CaseDuplicateCreator };
